export enum MenuMutationTypes {
    SET_CONTRATO = 'SET_CONTRATO',
    SET_CODIGOESCOLA = 'SET_CODIGOESCOLA',
    SET_CODIGOGRUPOUSUARIO = 'SET_CODIGOGRUPOUSUARIO',
    SET_CODIGOPROFESSOR = 'SET_CODIGOPROFESSOR',
    SET_CODIGORESPONSAVEL = 'SET_CODIGORESPONSAVEL',
    SET_CODIGOALUNO = 'SET_CODIGOALUNO',
    SET_CODIGOUSUARIO = 'SET_CODIGOUSUARIO',
    SET_ANO = 'SET_ANO',
    SET_SEMESTRE = 'SET_SEMESTRE',
    SET_READONLY = 'SET_READONLY',
    SET_CHAMADA_VIA_PROXY = 'SET_CHAMADA_VIA_PROXY',
    SET_CODIGOENSINO = 'SET_CODIGOENSINO',
}
